import React from "react";

const Informationwidget = ({ data, title }) => {
    return (
        <>
            {data && Object.keys(data).length ?
                <div className="whiteCard routeInformation">
                    <h2>{title ? title : "Route Informations"}</h2>
                    <table className="routeTable" width="100%">
                        {Object.keys(data).map((key, index) => {
                            return (
                                <tr key={index} className="routeTableRow">
                                    <td className="infoTitle">{key}</td>
                                    <td className="infoText">{data[key]}</td>
                                </tr>
                            )
                        }
                        )}
                    </table>
                </div>
                : <></>
            }
        </>
    );
}

export default Informationwidget;
